// extracted by mini-css-extract-plugin
export default {"root":"ProductTable_root__5wk+B","product":"ProductTable_product__fmWw5"};